import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ACCESSTOKENLOCALSTORAGE } from 'app/localStorage';
import { useEffectOnce } from 'hooks/useEffectOnce';
import MenuIcon from '@mui/icons-material/Menu';
import { useAppDispatch, useAppSelector } from '@myRedux/hooks';
import { selectApiRoot } from '@myRedux/api/apiSlice';
import { getUserFromAccessTokenAsync, selectLoggedInUserInfo } from '@myRedux/user/userFromSessionSlice';
import { Button } from '@componentLibraryWrapper/button';
import { Box } from '@componentLibraryWrapper/box';
import { AppBar } from '@componentLibraryWrapper/appbar';
import { Toolbar } from '@componentLibraryWrapper/toolbar';
import { Popper } from '@componentLibraryWrapper/popper';
import Login from './components/login/login';
import UserMenu from './components/userMenu/userMenu';
import { Container } from '@componentLibraryWrapper/container';
import GridContainer from '@commonComponent/grid/gridContainer';
import './navbar.scss'

const Navbar = () => {
	const dispatch = useAppDispatch();

	const apiSelector = useAppSelector(selectApiRoot);
	const loggedInUserSelector = useAppSelector(selectLoggedInUserInfo);

	const [popperAnchorEl, setpopperAnchorEl] = useState<HTMLButtonElement | null>(null);
	const [triggerPopper, setTriggerPopper] = useState(false);
	const [initialLoadComplete, setInitialLoadComplete] = useState(false);

	useEffectOnce(() => {
    setInitialLoadComplete(true)
  })

  useEffect(() => {
    if (initialLoadComplete && apiSelector.value) {
      var accessToken = localStorage.getItem(ACCESSTOKENLOCALSTORAGE);
			if (accessToken) {
					dispatch(getUserFromAccessTokenAsync());
			}
    }
  }, [dispatch, initialLoadComplete, apiSelector])

	function handleLoginOrUserClick(event: React.MouseEvent<HTMLButtonElement>) {
		setpopperAnchorEl(event.currentTarget);
		setTriggerPopper(!triggerPopper);
	}

	function handleGridContainerMouseDown(event: React.MouseEvent<HTMLDivElement>) {
		if (event.target === event.currentTarget) {
      onClickAway(event.nativeEvent);
    }
	}

	function onClickAway(e: MouseEvent | TouchEvent) {
		if (e.target !== popperAnchorEl) {
			if (!popperAnchorEl?.contains(e.target as HTMLElement)) {
				setTriggerPopper(false);
			}
		}
	}

	function onLoginSuccess() {
		closePopper();
		window.location.reload();
	}

	function onLogout() {
		closePopper();
		window.location.reload();
	}

	function closePopper() {
		setTriggerPopper(false);
	}

	return (
		<Box
			className="schoolmerge-navbar"
		>
			<AppBar position="static">
				<Toolbar>
					<div
						className='schoolmerge-title flex-grow-1'>
						<h2>
							<Link to="/">
								SchoolMerge
						</Link>
						</h2>
					</div>
					<Button
						color="inherit"
						onClick={handleLoginOrUserClick}
					>
						{loggedInUserSelector.value ? 
							<><MenuIcon/></>
						:	<>Login / Signup</>}
					</Button>
				</Toolbar>
			</AppBar>
				{triggerPopper &&
					<Popper
						arrow
						anchorEl={popperAnchorEl}
						className='navbar-popper'
						onClickAway={onClickAway}
						open={triggerPopper}
						placement='bottom'
					>
						<Container
							className='navbar-popper-container'
							maxWidth='xl'>
							<GridContainer
								id="navbar-popper-gridcontainer"
								justifyContent='flex-end'
								onMouseDown={handleGridContainerMouseDown}
								spacing={0}
							>
								{loggedInUserSelector.value ?
									<UserMenu
										onLogout={onLogout}
									/>
								: <Login
										onLoginSuccess={onLoginSuccess}
									/>}
							</GridContainer>
						</Container>
					</Popper>}
		</Box>
	);
}

export default Navbar;